import { render, staticRenderFns } from "./questionnaireplantopic.vue?vue&type=template&id=4b5694d1&"
import script from "./questionnaireplantopic.vue?vue&type=script&lang=js&"
export * from "./questionnaireplantopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports